<template>
  <div>
    <div class="contain">
      <img src="@/assets/images/404.jpg" />
    </div>
    <div class="foot">
      <van-button type="default"  @click="onBackHome">返回首页</van-button>
    </div>
  </div>
</template>

<script>
export default {

    methods:{
        onBackHome(){
            this.$router.replace("/")
        }
    }

};
</script>

<style  scoped>
    .contain{
        padding:0 0 5px 0;

    }
    .foot{
        text-align: center;

    }

</style>
